import React from 'react';
import styled from 'styled-components';

import Icon from '../Icon';

function Error({halfScreen, fullScreen, message}) {
  return (
    <Container halfScreen={halfScreen} fullScreen={fullScreen}>
      <Icon name="alert-circle" size="4.5em" color="#b4b4b4" />
      <Message>
        {message ? (
          <p>{message}</p>
        ) : (
          <p>An unexpected problem occurred.</p>
        )}
      </Message>
    </Container>
  );
}

const Container = styled.div`
  height: ${props => props.fullScreen ? '100vh' : props.halfScreen ? '45vh' : '100%'};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Message = styled.div`
  margin-left: 1rem;
  color: #747474;
`;

export default Error;